import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { apiBaseUrl } from './config'
import { consoleLog, consoleError, consoleInfo } from '@/utils/logger'
import './assets/theme.css'

consoleLog('✅ Application en cours de démarrage...')
consoleLog('🔗 API URL:', apiBaseUrl)

const app = createApp(App)

// Configuration d'erreur globale
app.config.errorHandler = (err, instance, info) => {
  consoleError('Vue Error:', err)
  consoleInfo('Error Info:', info)
}


import vue3GoogleLogin from 'vue3-google-login'

app.use(router)
app.use(i18n)

// Configuration Google Login
app.use(vue3GoogleLogin, {
  clientId: '14194066058-h4ompr7u89dkvbuh6fpfdlimhlea5p9p.apps.googleusercontent.com',
  // Forcer le popup flow pour obtenir un ID token au lieu d'un code
  popupType: 'TOKEN'
})

app.mount('#app')
